
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["less_body", "more_body", "more_link", "less_link"]
}
